import { SORT_DIRECTIONS_ENUM } from "config/constants";

export enum LOADING_STATE {
  idle = "idle",
  pending = "pending",
  fulfilled = "fulfilled",
  rejected = "rejected",
}

export type TServiceError = {
  code: number;
  message: string;
};

export type TTableSortParams = {
  sortField: string | null;
  sortOrder: SORT_DIRECTIONS_ENUM | null;
};
